import { Random } from '../Math';
import { Entity } from './Entity'
export interface IGenParams {
    low: number;
    med: number;
    high: number;
}

type EntityDistance = {
    name: string;
    entity: Entity;
    distance: number;
}


export class AbstractGenerator {
    public readonly entities: EntityDistance[] = [];
    public currentWishes: IGenParams;

    constructor(
        public wishes: IGenParams,
        public wishesSpeed: IGenParams,
        public presentWorld: () => IGenParams,
        public stupidity: number,
        public chaosFactor: number,
    ) {
        this.currentWishes = <IGenParams>{};
        Object.keys(this.wishes).forEach(key => {
            this.currentWishes[key] = 0;
        });

    }

    public spawn(): void {
        Object.keys(this.wishes).forEach(key => {
            if (this.currentWishes[key] != this.wishes[key]) {
                this.currentWishes[key] += this.wishesSpeed[key];
            }
        });

        // calc the enities distance and sort them
        const present = this.presentWorld();

        this.entities.forEach((entity) => {
            entity.distance = this.calcWishesDistance(entity.entity.usefulness(), present);
        });
        this.entities.sort((a, b) => {
            const distance = a.distance - b.distance;
            if (distance == 0) {
                return Math.round(Random()) ? -1 : 1;
            }
            else {
                return distance;
            }
        });

        if (!this.chaosFactor && !this.stupidity) {
            this.entities[0].entity.spawn();
        }
        else {
            const r = Math.random();
            if (r > this.chaosFactor) {
                //use stupidity to select the new one to spawn
                if (Math.tanh(r * Math.PI) < this.stupidity) {
                    //stupid choosing
                    //TODO: просмотреть еще раз распределение с выбором приоритета на 0 элементе
                    const variety = (1 - Math.tanh(Math.random() * Math.PI));
                    this.entities[Math.round(variety * (this.entities.length - 1))].entity.spawn();
                } else {
                    //genious choosing
                    this.entities[0].entity.spawn();
                }
            } else {
                this.entities[Math.round(Math.random() * (this.entities.length - 1))].entity.spawn();
            }
        }

    }

    public addNewEntity(name: string, entity: Entity): void {
        this.entities.push(<EntityDistance>{ name, entity, distance: 9999 });
    }

    private calcWishesDistance(aim: IGenParams, present: IGenParams): number {
        let magnitude = 0;
        const keys = Object.keys(this.wishes);
        keys.forEach((key: string) => {
            magnitude += Math.pow(((aim[key] + present[key]) - (this.wishes[key])), 2);
        });
        return Math.sqrt(magnitude);
    }
}